import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { ClientsRequestModel } from '../../helpers/objects/request/clients/clients-request-model';
import { map, Observable } from 'rxjs';
import { ClientsResponseModel } from '../../helpers/objects/response/clients/clients-response-model';
import { ClientsModel } from '../../helpers/objects/dto/clients/clients-model';
import { Router, UrlSerializer } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel,
    private serializer: UrlSerializer,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.appConfig = appConfigTemp;
  }

  get(filter: ClientsRequestModel): Observable<ClientsResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'clients/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as ClientsResponseModel));
  }

  getDetails(id: string): Observable<ClientsModel> {
    return this.http
      .get<any>(this.appConfig.api + 'clients/' + this.appConfig.apiPartnershipId + '/' + id)
      .pipe(map((response) => response.body.client as ClientsModel));
  }

  download(filter: ClientsRequestModel): string {
    const extraParams = {
      pageSize: 10000,
      page: 1,
      Authorization: sessionStorage.getItem('token'),
      location: this.translateService.currentLang
    };
    const params = { ...filter, ...extraParams };
    const query = this.router.createUrlTree([], { queryParams: params });
    return this.appConfig.api + 'clients-worksheet/' + this.appConfig.apiPartnershipId + '?' + (this.serializer.serialize(query).split('?')[1] || '');
  }
}
